<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Désactiver des options</div>
</div>
<div class="col-12">
    @if (filteredOptions.length == 0) {
        <div class="bold-red-text text-center">Nous vous informons qu’aucune option n’est actuellement active sur votre ligne, donc aucune désactivation n’est nécessaire.</div>
    }
    @for (option of filteredOptions; track option; let i = $index) {
        <div class="bold-label-option">
            Souhaitez-vous désactiver l'option {{ option.labelEc }} ?
            <div class="radio-group ml-3">
                <div class="radio-options">
                    <label [for]="'no_response_' + option.id">
                        <input type="radio" [id]="'no_response_' + option.id" [name]="option.id" checked (click)="update('no', option.id)">Non
                    </label>

                    <label [for]="'yes_immediate_response_' + option.id">
                        <input type="radio" [id]="'yes_immediate_response_' + option.id" [name]="option.id" (click)="update('immediate', option.id)">Oui immédiatement
                    </label>

                    <label [for]="'yes_at_renewal_response_' + option.id">
                        <input type="radio" [id]="'yes_at_renewal_response_' + option.id" [name]="option.id" (click)="update('renewal', option.id)">Oui avant le prochain renouvellement
                    </label>
                </div>
            </div>
        </div>
    }
    <div class="row w-100 pt-3 text-center">
        <div class="col-12 w-100 cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            @if (data.atRenewal.length > 0 || data.immediate.length > 0) {
                <button type="button" class="cta_btn level_2 column" (click)="save()">Valider<span></span></button>
            }
        </div>
    </div>
</div>